export const downloadFile = (data, fName, extension = "xls") => {
  var href = window.URL.createObjectURL(data)
  const link = document.createElement("a")
  link.href = href
  link.setAttribute("download", "report_" + fName + "." + extension)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}
